import {ChangeDetectorRef, Component, InjectionToken, Input, NgZone, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Router} from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {_} from 'underscore';
import {Guide} from '../../mock/Guide';
import { RouterService } from '../../service/RouterService';
export const MY_TOKEN = new InjectionToken<string>('MyToken');

@Component({
  selector: 'o2-tour',
  templateUrl: './o2-tour.component.html',
  styleUrls: ['./o2-tour.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class O2TourComponent implements OnInit {
  public allElement = [];
  public index = -1;
  public lenPage = 0;
  public _page = '';
  public _isActive = false;
  public _isActiveDialog = false;
  public _isNext = false;
  public _isPrev = true;
  public _toSerach = '';
  public current: any = {
    class: '',
    title: '',
    description: '',
    contains: '',
    useQuestion: false,
    to: undefined,
    suggestion: [],
    time: undefined,
    actions: []
  };
  public pages = [];
  public suggestion = [];
  public element = {
    top: {style: {width:0, height:0, left:0, top:0}},
    left: {style: {width:0, height:0, left:0, top:0}},
    right: {style: {width:0, height:0, right:0, top:0}},
    bottom: {style: {width:0, height:0, left:0, bottom:0}}
  };
  public questiones: any = [];
  public _scenario : any = {
    timesheet: [
      {class: 'app-sidebar', title: 'View My Sheet ', description: 'Block my sheet'},
      {class: '.mytimesheet', title: 'View My Sheet ', description: 'Block my sheet'},
      {class: '.profil-card', title: 'Profil Card', description: 'actions logout/dashboard'},
      {class: '.hierarchy-tree', title: 'Tree', description: 'View les agents'},
      {class: '.production', title: 'Production', description: 'Production'}
    ]
  };
  @Input()
  public set scenario(v: any) {
    this.setScenario(v);
  }

  private setScenario(v: any) {
    this._scenario = v;
    Object.keys(this._scenario).forEach((page) => {
      this.pages.push({
        url: page,
        icon: this._scenario[page].icon,
        title: this._scenario[page].title,
      });
    });
  }

  @Input()
  public set page(page: any) {
    this._page = page
  }
  constructor(private router: Router, private ngZone: NgZone, private rs: RouterService,private translate: TranslateService) {
    this.rs.showGuide.subscribe(show => {
      if (this._page in this._scenario) {
        this.ngZone.run(() => {
          this.questiones = this._scenario[this._page].data.filter(e => e.useQuestion);
          this._isActiveDialog = true;
          this._isActive = false;
        });
      } else {
        console.log('Auccune senario pour cette page: ' + this._page);
      }
    });
    this.setScenario(Guide[this.translate.currentLang]);
    router.events.subscribe((e: any) => {
      if (typeof e.url != 'undefined') {
        this._page = (e.url == '/' ? e.url : e.url.replace('/', ''));
        this._page = (this._page.indexOf('?') > -1 ? '/' : this._page);
      }
    });

    document.body.addEventListener('DOMNodeInserted', (e: any) => {
      //console.log(this._page)
      //let el = e.target.classList
      if(this._page in this._scenario) {
        this._scenario[this._page].data.forEach((s: any) => {
          let element = document.querySelector(s.class);
          if(element) {
            s['isPresent'] = true;
          }
        })
      }
    })
  }

  ngOnInit() {
    //this._scenario = this.Guide;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.pages=[];
      this.setScenario(Guide[this.translate.currentLang]);
    });
  }
  getSuggestion() {
    this.suggestion = [];
    if(this.current && this.current.suggestion) {
      this.current.suggestion.forEach((e) => {
        if(e.length > 0 && e.indexOf('|')) {
          let xpath = e.split('|')
          if(xpath[0] in this._scenario) {
            this._scenario[xpath[0]].data.forEach((s: any) => {
              if(s.class == xpath[1]) {
                this.suggestion.push(s);
              }
            })
          }
        }
      })
    }
  }
  switchIndex(index?) {
    switch (index) {
      case 'next': this.index = this.index + 1; break;
      case 'back': this.index = this.index - 1; break;
      case 'reset': this.index = 0; break;
    };
  }
  openPage(url) {
    this.router.navigateByUrl(url);
    this.open()
  }
  openWith(q) {
    if (q) {
      let element = document.querySelector(q.class);
      if (!element) {
        this._toSerach = q.class;
        this.Next('next');
      } else {
        console.log('_scenario :', this._scenario[this._page], q.class);
        this._scenario[this._page].data.forEach((d, i) => {
          if (q.class == d.class) {
            this.index = i - 1;
          }
        });
        this.Next('next');
        this._toSerach = '';
      }
      this._isActiveDialog = false;
      //console.log('Goto:', q, '| Search:', this._toSerach)
    } else {
        console.log('element undefined');
    }
  }
  open() {
    if (this._page in this._scenario) {
      console.log(' open in ', this._page, this._scenario, this._isActiveDialog, this._isActive);
      this.ngZone.run(() => {
        this.questiones = this._scenario[this._page].data.filter(e => e.useQuestion);
        this._isActiveDialog = true;
      });
    } else {
      console.log('Auccune senario pour cette page: ' + this._page);
    }
  }
  Next(index?) {
    this.ngZone.run(() => {
      let $this = this;
      this.switchIndex(index);
      this.goTo(this.index);
      this._isActive = this.index > -1;
      this.current = this.getPageByIndex();

      this.getSuggestion();
      if ( Object.keys(this._scenario).length > 0) {
        let bd = document.body.getBoundingClientRect();
        // console.log('this.current:', this.current, this.ge(this.current.class));
        if(this.ge(this.current.class)) {
          var element = this.ge(this.current.class);
          let e = element.getBoundingClientRect();
          element.style.position = 'relative';
          element.style.zIndex = '999';
          let _current = this.current;
          let _toSerach = this._toSerach;
          if(this.current.to) {
            element.onclick = function(e) {
              if($this.current.to && $this.current.to.length > 0 && $this.current.to.indexOf('|')) {
                let xpath = $this.current.to.split('|');
                if(xpath[1] == 'close') {
                  $this._isActive = false;
                }
                if('/' + xpath[0] !== $this.router.url ) {
                  $this.router.navigate(['/' + xpath[0]])
                }
                $this.interActive($this, xpath[1]);
                if($this._toSerach.length == 0) {

                  console.log('Hello xpath')

                } else {
                  console.log('Hello in search')
                  //  $this.interActive($this, $this._toSerach)
                }
              } else {
                $this.interActive($this, $this._toSerach)
                console.log('Hello out search')
              }
            }
          }
          this.allElement.push(element);
          let card = this.ge('o2-tour .o2-card-details')
          let top = this.ge('o2-tour .o2-top')
          let left = this.ge('o2-tour .o2-left')
          let right = this.ge('o2-tour .o2-right')
          let bottom = this.ge('o2-tour .o2-bottom')

          top.style.width = `100%`;
          top.style.height = `${e.top}px`;

          left.style.width = `${e.left}px`;
          left.style.top = `${e.top}px`;
          left.style.height = `${e.height}px`;

          right.style.top = `${e.top}px`;
          right.style.width = `calc(100% - ${e.width + e.left}px)`
          right.style.height = `${e.height}px`

          bottom.style.height = `calc(100vh - ${(e.top +  e.height)}px)`;


          var maxSize = 350;
          var maxSizeCalc = document.body.offsetWidth;
          card.classList.remove('arrow-right')
          card.classList.remove('arrow-left')

          setTimeout(() => {
            card.style.top = `${e.top + (e.height / 2) - 15 }px`;

            if(e.left + card.offsetWidth + e.width  > window.innerWidth ) {

              card.style.left = `${(e.left -  card.offsetWidth - 10)}px`;
              card.classList.add('arrow-right')

            }
            if( e.left <= maxSize ) {

              card.style.left = `${(e.left + e.width + 10 )}px`
              card.classList.add('arrow-left')

            }
            else {

              card.style.left = `${(e.left -  card.offsetWidth - 10)}px`;
              card.classList.add('arrow-right')

            }

            if(e.top + card.offsetHeight >=  window.innerHeight) {
              card.style.top = `${(e.bottom -  card.offsetHeight)}px`;
            }

            if(card.offsetHeight > bottom.offsetHeight && card.offsetHeight < top.offsetHeight ) {
              card.style.top = `${(e.bottom -  card.offsetHeight)}px`
              card.classList.add('HERE')
            }


            /*if(bottom.offsetHeight == 0) {
              card.style.top = `${e.top - card.offsetHeight + 100}px`;
              if(left.offsetWidth == 0) {
                card.style.left = `${(e.left)}px`;
              }
              if(right.offsetWidth == 0) {
                card.style.left = `${(e.left)}px`;
              }
              if(left.offsetWidth != 0 && right.offsetWidth != 0) {
                card.style.left = `${(e.left + (card.offsetWidth / 2))}px`;
              }
            }*/
            /*if(left.offsetHeight == 0 || card.offsetWidth >= left.offsetWidth) {
              card.style.left = `${e.left + e.width + 15 }px`;
              card.classList.add('arrow-right')
            }

            if(right.offsetHeight == 0 || card.offsetWidth >= right.offsetWidth) {
              card.style.left = `${e.left - card.offsetWidth}px`;
              card.classList.add('arrow-left')
            } else if((card.offsetWidth >= right.offsetWidth) && (card.offsetWidth >= left.offsetWidth)) {
              console.log('OUT')
            } else if(!(card.offsetWidth >= right.offsetWidth) && !(card.offsetWidth >= left.offsetWidth)) {
              console.log('!OUT')
              card.style.left = `${e.left - (card.offsetWidth / 2 ) + (e.width / 2)}px`;
              card.classList.add('arrow-left')

            }



            if(top.offsetHeight == 0 || card.offsetHeight >= top.offsetHeight) {
              card.style.top = `${e.top + element.offsetHeight + 15 }px`;
              card.classList.add('arrow-top')
            } else if(bottom.offsetHeight == 0 || card.offsetHeight >= bottom.offsetHeight) {
              card.style.top = `${e.top - element.offsetHeight - 15 }px`;
              card.classList.add('arrow-bottom')
            } else {
              card.style.top = `${e.top}px`;
            }*/
            //          element.scrollIntoView();
          }, 100)

          /*    if( e.top <= maxSize)  {
                card.style.top = `${(e.top)}px`
                console.log('TOP')
              }

              if((maxSizeCalc - e.top) <= maxSize) {
                card.style.top = `${(e.bottom)}px`
                console.log('Bottom')
              }
    */



          /*if( (e.left >= 0 && e.left <= maxSize) && (e.top >= 0 && e.top <= maxSize)) {

            card.style.left = `${(e.left + element.offsetWidth + 5 )}px`
            card.style.top = `${(e.top)}px`
            console.log('LEFT | TOP')

          } else if( (e.left >= 0 && e.left <= maxSize) && (e.bottom >= 0 && e.bottom <= maxSize)) {

            card.style.left = `${(e.left + element.offsetWidth - 2)}px`
            card.style.top = `${(e.top - element.offsetHeight - 2)}px`
            console.log('LEFT | BOTTOM')

          } else if( ( (maxSizeCalc - e.left) <= maxSize) && (e.top >= 0 && e.top <= maxSize)) {

            card.style.left = `${(e.left - element.offsetWidth - 2)}px`
            card.style.top = `${(e.top + element.offsetHeight - 2)}px`

            console.log('RIGHT | TOP')

          } else if( (e.left >= 0 && e.right <= maxSize) && (e.bottom >= 0 && e.bottom <= maxSize)) {

            card.style.left = `${(e.left - element.offsetWidth - 2)}px`
            card.style.top = `${(e.top - element.offsetHeight - 2)}px`

            console.log('RIGHT | BOTTOM')
          } else  {
            card.style.left = `${(e.left - card.offsetWidth)}px`
            console.log('>> RIght ')
          }*/

        }else{
          this.Next(index)
        }
      }
    })
  }
  /**
    Get Element By Selector
   */
  ge(e) {
    return (e.length == 0 ? null : document.querySelector(e));
  }
  isPrev(){
    if (this._page !== ""){
      const len = (this.index == 0);
      if (!len) {
        this.index = this.index - 1
      }
      return len;
    }
  }
  goTo(index){
    if (this._page !== ""){
        this._isNext = (this.index == this.getScenarioByPage().length - 1 );
        this._isPrev = (this.index == 0);
        if(this._isNext) this.index = this.getScenarioByPage().length - 1;
        if(this._isPrev) this.index = 0;
        this._isActive = this.index > -1;
    }
  }
  to(index) {
    this.Next(index)
  }
  getScenarioByPage() {
    if (Object.keys(this._scenario).indexOf(this._page) > -1) {
      return this._scenario[this._page].data;
    }else{
      return [{class: '', title:'Information', description: 'Aucun information dans cette page'}];
    }
  }
  getPageByIndex() {
    const page = this.getScenarioByPage();
    this.lenPage = page.length
    return ( this.index <= page.length ? page[this.index] : page[0]);
  }
  Close(arg?: any) {
    this.index = -1;
    this._isActive = false;
    this._isActiveDialog = false;
    this._toSerach = '';
    this.allElement.forEach((el) => {
      el.onclick = null;
    })
  }
  async interActive($this, _toSerach?){
    //console.log('Offset', e.srcElement.offsetParent)
    if(_toSerach.length > 0) {
      var t = setInterval(() => {
        if(_toSerach.length == 0) {
          clearInterval((t))
        }
        var button = document.querySelector(_toSerach);
        if(button) {
          var q = $this._scenario[$this._page].data.filter(e => e.class == _toSerach)[0];
          setTimeout(() => {
            $this.openWith(q)
            clearInterval((t))
          }, 100)
        }
      }, 5);
    }else{
      // ToDo next
      console.log('ToDo')
    }
  }
  async loading(time = 100, callback?) {
    var sd = 113;
    var i = 0;
    let el = <HTMLElement>document.querySelector('svg.loadingTimeout circle');
    console.log('Get El', el)
    if(!el) return;
    var t = setInterval(() => {
      el.style.strokeDashoffset = i + 'px';
      ++i
      if(i > sd) {
        el.style.strokeDashoffset = 0 + 'px'
        if(callback) {
          setTimeout(() => {
            callback()
            console.log('Calling ')
          }, 100)
        }
        console.log('Finished')

        clearInterval(t)
      }
    }, time);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/o2-tour/o2-tour.component.ts